/**
 * Fantasy Console 0 - SFX Selector Component
 *
 * 8x8 grid of 64 SFX slots for selecting which SFX to edit.
 */

import type { SFX } from '@fc0/types'
import { sfxHasContent } from '../../utils/soundUtils'
import styles from './SFXSelector.module.css'
import editorStyles from '../../styles/editor.module.css'

interface SFXSelectorProps {
  sfxBank: SFX[]
  selectedIndex: number
  onSelect: (index: number) => void
}

export function SFXSelector({
  sfxBank,
  selectedIndex,
  onSelect,
}: SFXSelectorProps) {
  return (
    <div className={`${editorStyles.panelContainer} ${styles.container}`}>
      <div className={editorStyles.panelHeader}>
        <span className={editorStyles.panelLabel}>SFX Picker</span>
        <span className={editorStyles.panelInfo}>#{selectedIndex}</span>
      </div>
      <div className={styles.grid}>
        {sfxBank.map((sfx, i) => (
          <button
            key={i}
            className={`${styles.slot} ${i === selectedIndex ? styles.selected : ''} ${sfxHasContent(sfx) ? styles.hasContent : ''}`}
            onClick={() => onSelect(i)}
            title={`SFX ${i}`}
          >
            {i}
          </button>
        ))}
      </div>
    </div>
  )
}
